<template>
    <div v-if="imgurl" class="img-statisch-div">
        <img id="img-statisch" :src="imgurl" />
    </div>
</template>
<script>
export default {
    mixins: [],
    props: [],
    data() {
        return {
            apiUrl: null,
            uuid: null,
            screensize: {
                width: 0,
                height: 0
            },
            bilddauer: 5000
        }
    },
    computed: {
        imgurl() {
            let apiUrl = process.env.VUE_APP_API_URL;
            let uuid = window.location.pathname.slice(1).replace('kompatibel/', '');
            return apiUrl+'/api/imgurl-kompatibel?uuid='+uuid+'&rand='+Math.random(0, 1000000)+'&width='+this.screensize.width+'&height='+this.screensize.height;
        }
        
    },
    watch: {},
    methods: {},
    mounted() {
        this.screensize = {
            width: window.innerWidth,
            height: window.innerHeight
        };
        setTimeout(() => {
            window.location.reload();
        }, this.bilddauer);
    },

}
</script>
<style>
</style>
